import { AppointmentSummary } from '../types/common';
import {
  DashboardBookingHistory,
  DashboardReviewHistory,
  DashboardTransactionHistory,
} from '../types/dashboard';

export const TRANSACTION_HISTORY: Array<DashboardTransactionHistory> = [
  {
    id: 1,
    transaction_id: 'TrXDgIksOplKDiG',
    transaction_date: '20-02-2024',
    transaction_time: '11:00 AM',
    paid_amount: 4.52,
    purchased_credit: 112,
  },

  {
    id: 2,
    transaction_id: 'AbC123dEf456GhI',
    transaction_date: '13-03-2024',
    transaction_time: '02:30 PM',
    paid_amount: 15.75,
    purchased_credit: 300,
  },

  {
    id: 3,
    transaction_id: 'ZyX789wVu321QrT',
    transaction_date: '05-01-2024',
    transaction_time: '09:15 AM',
    paid_amount: 8.9,
    purchased_credit: 200,
  },

  {
    id: 4,
    transaction_id: 'LmN456oPq789RsU',
    transaction_date: '25-06-2024',
    transaction_time: '04:45 PM',
    paid_amount: 12.3,
    purchased_credit: 150,
  },

  {
    id: 5,
    transaction_id: 'DeF321gHi654JkL',
    transaction_date: '17-04-2024',
    transaction_time: '11:30 AM',
    paid_amount: 20,
    purchased_credit: 400,
  },
];

export const BOOKING_HISTORY: Array<DashboardBookingHistory> = [
  {
    id: 1,
    associate_name: 'Jim Brown',
    appointment_date: '20-04-2024',
    starting_time: '10:00 AM',
    ending_time: '11:00 AM',
    duration: 60,
    credit_used: 34.5,
  },

  {
    id: 2,
    associate_name: 'William Garcia',
    appointment_date: '29-02-2024',
    starting_time: '01:00 PM',
    ending_time: '02:00 PM',
    duration: 60,
    credit_used: 48.6,
  },

  {
    id: 3,
    associate_name: 'Mia Rodriguez',
    appointment_date: '14-12-2024',
    starting_time: '12:45 PM',
    ending_time: '01:45 PM',
    duration: 60,
    credit_used: 50.3,
  },

  {
    id: 4,
    associate_name: 'Angela Orange',
    appointment_date: '08-08-2024',
    starting_time: '09:00 AM',
    ending_time: '10:00 AM',
    duration: 60,
    credit_used: 39.4,
  },

  {
    id: 5,
    associate_name: 'Ava Wilson',
    appointment_date: '12-04-2024',
    starting_time: '10:30 AM',
    ending_time: '11:30 AM',
    duration: 60,
    credit_used: 28.5,
  },
];

export const APPOINTMENT_SUMMARY: Array<AppointmentSummary> = [
  {
    id: 1,
    client_name:
      'Aumi dsfkjhdjdkjfdsjfhkj dfjkhbnbhdfndsfhg fdjfkhdjsfhsdjhfksjdhfkjsdh jdhfjsdhfjh',
    client_email: 'aumi@kirrhosoft.com',
    client_location: 'New York, USA',
    appointment_date: '12-07-2024',
    allocated_time: '12:00PM - 02:00PM',
    total_duration: '1hr 55mins',
    status: 'Completed',
  },

  {
    id: 2,
    client_name: 'Aumi',
    client_email: 'aumi@kirrhosoft.com',
    client_location: 'New York, USA',
    appointment_date: '12-07-2024',
    allocated_time: '12:00PM - 02:00PM',
    total_duration: 'N/A',
    status: 'Pending',
  },

  {
    id: 3,
    client_name: 'Aumi',
    client_email: 'aumi@kirrhosoft.com',
    client_location: 'New York, USA',
    appointment_date: '12-07-2024',
    allocated_time: '12:00PM - 02:00PM',
    total_duration: 'N/A',
    status: 'Upcoming',
  },
];

export const CLIENT_REVIEWS: Array<DashboardReviewHistory> = [
  {
    id: 1,
    comments: 'Extraordinary service!!',
    ratings: 5,
    associate_name: 'Milhan Joardar Aumi',
    service_provided: 'Legal',
  },
  {
    id: 2,
    comments: 'Very helpful and professional.',
    ratings: 4,
    associate_name: 'Nadia Rahman',
    service_provided: 'Consulting',
  },
  {
    id: 3,
    comments:
      'Could have been more responsive, but overall good service. Could have been more responsive, but overall good service. Could have been more responsive, but overall good service. Could have been more responsive, but overall good service. Could have been more responsive, but overall good service.',
    ratings: 3,
    associate_name: 'Rafsan Jamil',
    service_provided: 'Financial Advisory',
  },
  {
    id: 4,
    comments: 'Exceptional attention to detail!',
    ratings: 5,
    associate_name: 'Tahmina Islam',
    service_provided: 'Legal',
  },
  {
    id: 5,
    comments: 'Satisfactory but felt a bit rushed.',
    ratings: 3,
    associate_name: 'Hasibul Alam',
    service_provided: 'Tax Consulting',
  },
  {
    id: 6,
    comments: 'Very professional and prompt!',
    ratings: 4,
    associate_name: 'Rehnuma Ahmed',
    service_provided: 'Financial Advisory',
  },
  {
    id: 7,
    comments: 'The service exceeded my expectations!',
    ratings: 5,
    associate_name: 'Tanvir Ahmed',
    service_provided: 'Consulting',
  },
];
